import { useCallback, useRef } from 'react'

import { useSafeState } from './use-safe-state'

/**
 * Hook that keeps track of the loading state of multiple fetch requests.
 *
 * @param {boolean} defaultState - specifies the default loading state
 */
export function useLoadingState(defaultValue = false) {
    const [requestCount, setRequestCount] = useSafeState(0)
    const defaultLoading = useRef(defaultValue)

    const setLoading = useCallback(
        isLoading => {
            if (isLoading) {
                setRequestCount(c => Math.max(c + 1, 1))
                if (defaultLoading.current) {
                    defaultLoading.current = false
                }
            } else {
                setRequestCount(c => Math.max(c - 1, 0))
            }
        },
        [defaultLoading, setRequestCount]
    )

    const isLoading = defaultLoading.current || requestCount > 0

    return [isLoading, setLoading]
}
